// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordContainer":"styles__forgotPasswordContainer___1HAzJ","forgotPassword":"styles__forgotPassword___azSAK"};